import React, { useEffect } from 'react';
import { Field, FieldProps } from 'react-final-form';

type ConditionalFieldProps = FieldProps<any, any> & {
  name: string;
  changeValue: (name: string, value: any) => void;
};

export const ConditionalField = ({ name, changeValue, ...props }: ConditionalFieldProps) => {
  useEffect(() => () => changeValue(name, undefined), [name, changeValue]);

  return <Field name={name} {...props} />;
};
